import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import hash from "object-hash";
import React, { useEffect } from "react";
import ReactTooltip from "react-tooltip";

interface Props {
  tooltipText: string;
  LeadIcon?: React.FC<any>;
}

export default function HintIconWithTooltip({ tooltipText, LeadIcon = QuestionMarkCircleIcon }: Props) {
  const hashedText = React.useCallback(() => hash(tooltipText), [tooltipText]);

  return (
    <div data-for={`callout_${hashedText()}`} data-tip={tooltipText} data-place="top">
      <LeadIcon className="h-5 w-5 text-gray-800" />
      <ReactTooltip id={`callout_${hashedText()}`} className="!opacity-95" effect="solid" delayShow={100} backgroundColor="#6b7280" />
    </div>
  );
}
